/**
 * Uniba ServiziOnline reducer
 * @module src/reducers/unibaServiziOnlineReducer
 */

import { GET_UNIBA_SERVIZIONLINE } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaServiziOnlineReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_SERVIZIONLINE}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_SERVIZIONLINE}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_SERVIZIONLINE}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
